export default [
  {
    id: 1,
    name: 'dias-corridos',
    label: 'Dias corridos',
  },
  {
    id: 2,
    name: 'competencia',
    label: 'Competencia',
  },
]
